import { render, staticRenderFns } from "./VueNavigation.vue?vue&type=template&id=226b991f&scoped=true"
import script from "./VueNavigation.vue?vue&type=script&lang=js"
export * from "./VueNavigation.vue?vue&type=script&lang=js"
import style0 from "./VueNavigation.vue?vue&type=style&index=0&id=226b991f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b991f",
  null
  
)

export default component.exports